import { createSlice } from "@reduxjs/toolkit";
import {
  BLACK,
  WHITE,
  BLUE600,
  BLUE200,
  MINT100,
  GREEN300,
  RED100,
  ORANGE100,
  YELLOW100,
  BLUE900,
  BLUE100,
  PURPLE100,
  GREY400,
  GREY300,
  GREY200,
  GREY100,
  BLACK_85,
  BLACK_80,
  BLACK_65,
  BLACK_45,
  BLACK_25,
  BLACK_10,
  WHITE_85,
  WHITE_80,
  WHITE_65,
  WHITE_45,
  WHITE_25,
  GREY300_65,
  GREY200_65,
  BLUE600_65,
  BLUE600_05,
  BLUE200_65,
} from "@/helpers/colors";

const initialState = {
   Black: BLACK, // WHITE ----- headline, copy,
   Blue600: BLUE600, // WHITE, ----------- FOCUSED --------- textinput, input underline, list texts, float, option, filter ,
   Blue200: BLUE200, // BLUE200  ---TOOLBAL DEFAULT ----Buttons
   Blue200_White: BLUE200, // WHITE  ---TOOLBAL DEFAULT ----Buttons
   White: WHITE, // BLUE600 ----- BACKGROUNDS
 
   Grey300: GREY300, // Grey200 -------- widgets, dislamer, hint  --------DISABLED TOOOLBAR ICON------
 
   Grey300_65: GREY300_65, // WHITE_65  -------- widgets, disclamer, hint
   Blue600_65: BLUE600_65, // WHITE_65
   White_65: WHITE_65, // WHITE_65
   Black_65: BLACK_65, // black_65
   Black_80: BLACK_80, // white_80
   White_80: WHITE_80, // bLUE_80
   White_Black: WHITE, // black
 
   Grey200_65: GREY200_65, // WHITE_65  -------- widgets, disclamer, hint
   Grey100: GREY100, // WHITE_25
   Grey200: GREY200, // grey300
   Grey200_Pressed: GREY200_65, // grey300-65
   Blue200_Pressed: BLUE200_65, // blue200_65 - Buttons ------
 
   Blue200_65: BLUE200_65, // WHITE_65 ---TOOLBAr pressed
};

const userSlice = createSlice({
  name: "colors",
  initialState,
  reducers: {
    toggleColors: (state, action) => {
      const { Black, Blue600, Blue200, Blue200_White, White, Grey300, Grey300_65, Blue600_65, White_65, Black_65,
        Black_80,White_80,White_Black,Grey200_65,Grey100,Grey200,Grey200_Pressed,Blue200_65 } = action.payload;
      state.Black = Black,    
      state.Blue600 = Blue600;
      state.Blue200 = Blue200;
      state.Blue200_White = Blue200_White;
      state.White = White;
      state.Grey300 = Grey300,    
      state.Grey300_65 = Grey300_65;
      state.Blue600_65 = Blue600_65;
      state.White_65 = White_65;
      state.Black_65 = Black_65;
      state.Black_80 = Black_80,    
      state.White_80 = White_80;
      state.White_Black = White_Black;
      state.Grey200_65 = Grey200_65;
      state.Grey100 = Grey100;
      state.Grey200 = Grey200,    
      state.Grey200_Pressed = Grey200_Pressed;
      state.Blue200_65 = Blue200_65;
      
    },
   
  },
});

export const { toggleColors } = userSlice.actions;
export default userSlice.reducer;
